import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M5.827.54a.5.5 0 0 1 .393 0l4.053 1.726a.5.5 0 0 1 .305.46v4.112l3.628 1.64a.5.5 0 0 1 .294.455v4.57a.5.5 0 0 1-.322.467l-3.922 1.497a.5.5 0 0 1-.371-.006l-8.078-3.375a.5.5 0 0 1-.307-.462V2.726c0-.2.12-.38.303-.46L5.827.54Zm3.75 6.284V3.46L6.526 4.653l.005 3.415 3.048-1.244ZM5.53 8.09l-.005-3.436L2.5 3.46v3.38l3.03 1.248ZM2.5 7.922v3.37l3.038 1.269-.006-3.39L2.5 7.922Zm4.033 1.662.005 3.395 3.04 1.27v-3.411L6.533 9.584Zm4.045 1.258v3.432l2.922-1.115V9.672l-2.922 1.17Zm2.146-1.937-2.656-1.2-2.748 1.12 2.76 1.137 2.644-1.058Zm-9.41-6.198 2.711 1.068 2.73-1.068-2.73-1.163-2.71 1.163Z';
const draw24px =
  'M9.428 2.435a.625.625 0 0 1 .533 0l4.728 2.219c.22.103.36.323.36.566v5.313l4.23 2.107a.625.625 0 0 1 .346.56v5.875c0 .252-.15.479-.383.576l-4.576 1.925a.625.625 0 0 1-.504-.008l-9.423-4.34a.625.625 0 0 1-.364-.568V5.22c0-.242.14-.462.358-.565l4.695-2.22Zm4.37 8.081V6.17l-3.477 1.5.006 4.408 3.472-1.562Zm-4.72 1.588L9.07 7.668 5.625 6.172v4.365l3.452 1.567Zm-3.453-.194v4.35l3.46 1.593-.006-4.375-3.454-1.568Zm4.705 2.136.006 4.384 3.463 1.594v-4.403l-3.47-1.575Zm4.719 1.58v4.433l3.326-1.399v-4.502l-3.326 1.468Zm2.48-2.46-3.119-1.554-3.223 1.45 3.24 1.472 3.102-1.369ZM6.514 5.195l3.182 1.381 3.205-1.382L9.696 3.69 6.514 5.194Z';
const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const CompositeBoxIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'compositeBox'),
) as IconWithRender;

CompositeBoxIcon.displayName = 'CompositeBoxIcon';
CompositeBoxIcon.propTypes = Icon.propTypes;
CompositeBoxIcon.renderIcon = (props) => <CompositeBoxIcon {...props} />;
export default CompositeBoxIcon;
